import React, { useEffect, useState } from "react";
import AddressNotBusinessVerifyModal from "../Modals/AddressVerifyModal";
import AddressPickerModal from "../Modals/AddressPickerModal";
import locationsService from "../../services/locationsService";
import exceptionService from "../../services/exceptionService";
import MDBox from "mdComponents/MDBox";
import MDTypography from "mdComponents/MDTypography";
import {
  Card,
  CircularProgress,
  Divider,
  FormHelperText,
  Grid,
  MenuItem,
  Switch,
} from "@mui/material";
import MDInput from "mdComponents/MDInput";
import MDButton from "mdComponents/MDButton";
import { useNavigate } from "react-router-dom";
import {
  amenitiesList,
  APP_NAME,
  BACKEND_BASE_URL,
  HOST_PRICING_PLANS,
  MESSAGES_ADDRESS_VERIFICATION,
  MESSAGES_LOCATION,
  MESSAGES_VALIDATION,
  states,
} from "../../constants";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import googleAPIService from "../../services/googleAPIService";
import { VerifyAddressInputType, VerifyAddressResultType } from "../../services/googleAPIService";
import NotificationAlert from "controls/NotificationAlert";
import { parseAddress } from "Utils";
import LocationHours from "controls/LocationHours";
import { formatPhoneNumber } from "Utils";
import LocationDoorLockHours from "controls/LocationDoorLockHours";
import PremiumOnlyImage from "components/LocationCreationImages/PremiumOnlyImage";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { validatePhone } from "../../Utils";
import { useNavigationMessageContext } from "../../context/NavigationMessageContext";
import { useUser } from "../../context/UserContext";
import { getCurrentSessionToken } from "../../services/auth";
import { Host } from "../../models/hostModel";
import { MainLogo } from "../../components/Icons/MainLogo";
import LocationAlreadyExistsModal from "components/Modals/LocationAlreadyExistsModal";
import HostingPlanSelector from "controls/HostingPlanSelector";
import LoadingSpinner from "controls/LoadingSpinner";
import AddLocationInstructionSection from "controls/AddLocationInstructionSection";

interface AddLocationProps {
  user: any;
  fromFailedPayment?: boolean;
  failedPaymentHost?: any;
}

const AddLocation: React.FC<AddLocationProps> = ({
  user,
  fromFailedPayment = false,
  failedPaymentHost = null,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const { setMessage } = useNavigationMessageContext();
  const { userCorporateAccount } = useUser();
  const [userDiscount, setUserDiscount] = useState<any>();

  const navigate = useNavigate();
  const [step, setStep] = useState<number>(1);
  const [saving, setSaving] = useState<boolean>(false);
  const [verifingAddress, setVerifingAddress] = useState<boolean>(false);
  const [checkingForLocationExits, setCheckingForLocationExits] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>({});

  const [showAddressNotBusinessVerifyModal, setShowAddressNotBusinessVerifyModal] = useState(false);
  const [showAddressPickerModal, setShowAddressPickerModal] = useState(false);
  const [showLocationAlreadyExistsModal, setShowLocationAlreadyExistsModal] = useState(false);

  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [stateValue, setStateValue] = useState("State");
  const [zip, setZip] = useState("");
  const [phone, setPhone] = useState("");
  const [is24Hours, setIs24Hours] = useState(true);
  const [businessHours, setBusinessHours] = useState();
  const [doorLockHours, setDoorLockHours] = useState();
  const [isBusiness, setIsBusiness] = useState(true);
  const [doorLockCodeRequired, setDoorLockCodeRequired] = useState(true);
  const [doorLockAlwaysLocked, setDoorLockAlwaysLocked] = useState(true);
  const [timeAllowed, setTimeAllowed] = useState(5);
  const [doorLockCode, setDoorLockCode] = useState(123456);
  const [useQRCode, setUseQRCode] = useState(false);
  const [localRep, setLocalRep] = useState("");

  const [addressVerificationErrorMessage, setAddressVerificationErrorMessage] = useState("");
  const [formValidateErrorMessage, setFormValidateErrorMessage] = useState("");
  const [saveComplete, setSaveComplete] = useState(false);
  const [agreeToRecurring, setAgreeToRecurring] = useState(false);
  const [couponCode, setCouponCode] = useState("");

  const [offerFamilyRestroom, setOfferFamilyRestroom] = useState(false);
  const [offerMenBabyChaningTable, setOfferMenBabyChaningTable] = useState(false);
  const [offerWomenBabyChaningTable, setOfferWomenBabyChaningTable] = useState(false);
  const [offerWetWipes, setOfferWetWipes] = useState(false);
  const [offerSeatCovers, setOfferSeatCovers] = useState(false);
  const [offerHandicapAccessible, setOfferHandicapAccessible] = useState(false);
  const [offerHandSanitizer, setOfferHandSanitizer] = useState(false);
  const [offerWomenProducts, setOfferWomenProducts] = useState(false);
  const [offerMenProducts, setOfferMenProducts] = useState(false);
  const [offerPetFriendly, setOfferPetFriendly] = useState(false);
  const [offersCharger, setOfferCarCharger] = useState(false);
  const [motorcycleFriendly, setMotorcycleFriendly] = useState(false);
  const [overnightAllowed, setOvernightAllowed] = useState(false);
  const [offerLuxury, setOfferLuxury] = useState(false);

  const [hostPremiumOnly, setHostPremiumOnly] = useState(false);
  const [processingPayment, setProcessingPayment] = useState(false);
  const [savingLocation, setSavingLocation] = useState(false);
  const [selectedPricingPlan, setSelectedPricingPlan] = useState(1);
  const [freeForeverAvailable, setFreeForeverAvailable] = useState(false);

  const [addressesForPicker, setAddressesForPicker] = useState<any[]>([]);
  const [addressPicked, setAddressPicked] = useState<number | null>(null);
  const [addressConfirmed, setAddressConfirmed] = useState(false);
  const [placeId, setPlaceId] = useState("");
  const [latitude, setLatitude] = useState<number | null>(null);
  const [longitude, setLongitude] = useState<number | null>(null);

  const [showSnackBar, setShowSnackBar] = useState(false);
  const [snackbar, setSnackbar] = useState({
    color: "success",
    content: "Location Saved Successfully!",
    title: "Save Successful",
    icon: "check",
    dateTime: "just now",
  });
  const openSnackBar = () => setShowSnackBar(true);
  const closeSnackBar = () => setShowSnackBar(false);

  const amenityStateMap: Record<string, { value: boolean; setter: (v: boolean) => void }> = {
    handicapAccess: {
      value: offerHandicapAccessible,
      setter: setOfferHandicapAccessible,
    },
    familyRestroom: {
      value: offerFamilyRestroom,
      setter: setOfferFamilyRestroom,
    },
    womenBabyChangingStation: {
      value: offerWomenBabyChaningTable,
      setter: setOfferWomenBabyChaningTable,
    },
    mensBabyChangingStation: {
      value: offerMenBabyChaningTable,
      setter: setOfferMenBabyChaningTable,
    },
    disposableSeatCovers: {
      value: offerSeatCovers,
      setter: setOfferSeatCovers,
    },
    petFriendly: {
      value: offerPetFriendly,
      setter: setOfferPetFriendly,
    },
    womensHygieneProducts: {
      value: offerWomenProducts,
      setter: setOfferWomenProducts,
    },
    mensHygieneProducts: {
      value: offerMenProducts,
      setter: setOfferMenProducts,
    },
    electricCarCharger: {
      value: offersCharger,
      setter: setOfferCarCharger,
    },
    motorcycleFriendly: {
      value: motorcycleFriendly,
      setter: setMotorcycleFriendly,
    },
    overnightParking: {
      value: overnightAllowed,
      setter: setOvernightAllowed,
    },
    offerLuxury: {
      value: offerLuxury,
      setter: setOfferLuxury,
    },
  };

  useEffect(() => {
    setMessage(`Add a Hosting Location`);
    return () => setMessage(undefined);
  }, [setMessage]);

  useEffect(() => {
    const checkHostCount = async () => {
      const count = await locationsService.getLocationsCount();
      setFreeForeverAvailable(count > -1 && count < 100);
    };
    checkHostCount();
  }, []);

  const doSave = async (
    subscriptionId: string,
    stripeCustomerId: string,
    stripeDiscount: string,
    freeForever: boolean
  ) => {
    setFormValidateErrorMessage("");
    try {
      setSaving(true);
      const newHost: Host = {
        id: -1,
        name: name.trim(),
        address: address.trim(),
        city: city.trim(),
        state: stateValue,
        zip: zip.trim(),
        phone: formatPhoneNumber(phone),
        latitude,
        longitude,
        timeAllowed,
        doorLockCode,
        useQRCode,
        closedForCleaning: false,
        placeId,
        offerFamilyRestroom,
        offerMenBabyChaningTable,
        offerWomenBabyChaningTable,
        offerSeatCovers,
        offerWetWipes,
        offerHandicapAccessible,
        offerPetFriendly,
        isBusiness,
        hostPremiumOnly,
        doorLockCodeRequired,
        offerHandSanitizer,
        subscriptionId: subscriptionId,
        stripeCustomerId: stripeCustomerId,
        stripeDiscount: stripeDiscount,
        is24Hours: is24Hours,
        hours: businessHours,
        freeForever,
        localRep,
        offerMenProducts,
        offerWomenProducts,
        motorcycleFriendly,
        overnightFriendly: overnightAllowed,
        offerAutoCharger: offersCharger,
        doorLockAlwaysLocked: doorLockCodeRequired,
        corporateAccountId: userCorporateAccount?.id,
        imageuri: null,
        icon: null,
        pinColor: null,
        currentRating: null,
        currentlyOpen: null,
        openTimeToday: null,
        closeTimeToday: null,
        closedToday: null,
        currentQue: null,
        isApproved: false,
        offerLuxury: offerLuxury,
      };

      if (fromFailedPayment && failedPaymentHost) newHost.id = failedPaymentHost.id;

      const result = await locationsService.insertLocation(newHost, user?.id);
      if (result === true) {
        setSaveComplete(true);
        //set
        setStep(7);
        //reset
        setSaving(false);
      } else {
        setSnackbar({
          color: "error",
          content: "Unable to Save Location. Please try again.",
          title: "Error Saving",
          icon: "error",
          dateTime: "just now",
        });
        openSnackBar();
      }
    } catch (error: any) {
      exceptionService.logError(error, "AddLocation.doSave", user?.id);
      setSnackbar({
        color: "error",
        content: "There was a problem saving. " + error.message,
        title: "Error Saving",
        icon: "error",
        dateTime: "just now",
      });
      openSnackBar();
    } finally {
      setSaving(false);
    }
  };

  const businessInfoVerifyLocationNotExists = async (addressPickedId?: number) => {
    let useAddress = address.trim();
    let useCity = city.trim();
    let useState = stateValue.trim();
    let useZip = zip.trim();
    if (addressPickedId) {
      const newAddy = addressesForPicker?.find((a) => a.id == addressPickedId);
      if (newAddy != null) {
        useAddress = newAddy.address;
        useCity = newAddy.city;
        useState = newAddy.state;
        useZip = newAddy.zip;
        setAddress(newAddy.address.trim());
        setCity(newAddy.city.trim());
        setStateValue(newAddy.state.trim());
        setZip(newAddy.zip.trim());
        setLongitude(newAddy.longitude);
        setLatitude(newAddy.latitude);
        setIsBusiness(newAddy.isBusiness);
        setPlaceId(newAddy.placeId);
        setAddressConfirmed(true);
      }
    }
    //check if a location already exists at this address
    const result = await locationsService.doesLocationExistAtAddress(
      useAddress,
      useCity,
      useState,
      useZip
    );

    if (result == true) {
      setCheckingForLocationExits(false);
      setShowLocationAlreadyExistsModal(true);
    } else {
      //set
      setCheckingForLocationExits(false);
      //set to step 2
      setStep(2);
    }
  };

  const resetForm = () => {
    setStep(1);
    setName("");
    setAddress("");
    setCity("");
    setZip("");
    setPhone("");
    setTimeAllowed(5);
    setLatitude(0);
    setLongitude(0);
    setUseQRCode(false);
    setDoorLockCode(123456);
    setAddressConfirmed(false);
    setPlaceId("");
    setOfferFamilyRestroom(false);
    setOfferMenBabyChaningTable(false);
    setOfferWomenBabyChaningTable(false);
    setOfferSeatCovers(false);
    setOfferWetWipes(false);
    setOfferHandicapAccessible(false);
    setOfferHandSanitizer(false);
    setOfferPetFriendly(false);
    setFormValidateErrorMessage("");
    setAddressVerificationErrorMessage("");
    setOfferCarCharger(false);
    setMotorcycleFriendly(false);
    setOvernightAllowed(false);
    setLocalRep("");
  };

  const handleBack = () => {
    if (step == 1) navigate("/locations");
    if (step == 7) resetForm();
    else setStep(step - 1);
  };

  const nextText = () => {
    return step == 6
      ? "Process Payment"
      : freeForeverAvailable && step == 5
      ? "Save Location"
      : step == 7
      ? "Go to Locations"
      : "Next";
  };
  const backText = () => {
    return step == 1 ? "Cancel" : step == 7 ? "Add Another Location" : "Back";
  };
  const handleNext = () => {
    switch (step) {
      case 1:
        //main business info - verify address
        if (validateBusinessInfo()) verifyAddress();
        return;
      case 2:
        //this is business hours - send them to door lock options
        setStep(3);
        return;
      case 3:
        //this is door lock setings - send them to amenities
        setStep(4);
        return;
      case 4:
        //this is amenities - send them to chose hosting plan
        setStep(5);
        return;
      case 5:
        //check if they are free - if they are, save the location now
        if (freeForeverAvailable) {
          //save the location and let savelocation method send them to step 7(confirmation)
          doSave("freeForever", user?.id, "freeForever", true);
          return;
        } else {
          //this is plan selection - send them to credit card enter information
          setStep(6);
          return;
        }
      case 6:
        //this is on the payment screen - process the payment and let process payment method send them to step 7(confirmation)
        handleSubmitCreditCardForm();
        return;
      case 7:
        navigate("/locations");
        return;
      default:
        break;
    }
  };

  const handleSubmitCreditCardForm = () => {
    if (!selectedPricingPlan) {
      setFormValidateErrorMessage("Please selecting a pricing plan");
    }
    //validate the recurring is acknowledged
    if (!agreeToRecurring) {
      setFormValidateErrorMessage("Please agree to recurring payments to continue");
      return;
    }
    //check discount code if one was entered
    if (couponCode && couponCode == "BETA2025") {
      setFormValidateErrorMessage("You entered an invalid discount code. Please try again.");
      return;
    }
    //process the payment
    processPayment();
  };

  const cardElement = (): any => {
    return <CardElement id="cardstripe" options={{ hidePostalCode: true }} />;
  };
  const processPayment = async () => {
    try {
      setProcessingPayment(true);

      //determine the selected productId
      const planId = HOST_PRICING_PLANS.find((a) => a.id == selectedPricingPlan)?.pricingId;

      //  const { paymentMethod, error }: any = {paymentMethod: 'card', error: null};
      if (!stripe || !elements) {
        setFormValidateErrorMessage(
          "Payment processing is not configured. Please contact support."
        );
        setProcessingPayment(false);
        return;
      }
      const { paymentMethod, error } = await stripe.createPaymentMethod({
        type: "card",
        card: elements.getElement(CardElement),
      });

      if (error) {
        setFormValidateErrorMessage(
          error.message == "Card details not complete"
            ? `Unable to process payment.${"\n"}Check your card details.`
            : error.message
        );
        setProcessingPayment(false);
        return false;
      }

      let response;
      if (fromFailedPayment) {
        //update the subscription
        response = await fetch(`${BACKEND_BASE_URL}/update-subscription`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${await getCurrentSessionToken()}`,
          },
          body: JSON.stringify({
            subscriptionId: failedPaymentHost.subscriptionId, // Pass the subscription ID
            newPriceId: planId,
          }),
        });
      } else {
        //process subscription
        response = await fetch(`${BACKEND_BASE_URL}/create-subscription`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${await getCurrentSessionToken()}`,
          },
          body: JSON.stringify({
            email: user?.email, // 'user@example.com', // User's email
            name: `${user?.firstName} ${user?.lastName}`,
            description: name, //sets to location company name
            paymentMethodId: paymentMethod.id, // 'pmc_1Qj7vvIk5duMG1vF3RYmRwoL',//'pmc_1Qj7vwIk5duMG1vFHHRPrheN',//'pm_card_visa', // Replace with a valid payment method ID
            planId: planId, // 'monthly_plan_id', // Replace with your Stripe plan ID
            couponCode: couponCode,
          }),
        });
      }
      const {
        subscriptionId,
        discount,
        error: subscriptionError,
        customerId,
      } = await response.json();
      if (subscriptionError) {
        exceptionService.logError(subscriptionError, "AddLocation.CreateSubscription", user?.id);
      }
      if (!subscriptionId) {
        if (subscriptionError) {
          if (
            subscriptionError ==
            "This promotion code cannot be redeemed because the associated customer has prior transactions."
          ) {
            setFormValidateErrorMessage(
              "You already used this coupon code. Please remove it and try again."
            );
          } else {
            setFormValidateErrorMessage(
              "There was a problem processing the subscription. Please try again later."
            );
          }
        } else {
          setFormValidateErrorMessage(
            "There was a problem processing your payment. Please try again."
          );
        }
      } else {
        if (fromFailedPayment) {
          locationsService.clearLocationFailedPayments(failedPaymentHost.id);
          //setFormValidateErrorMessage('Payment information updated!');
          navigate("/locations");
        } else {
          //set
          setUserDiscount(discount);
          //save the location
          doSave(subscriptionId, customerId, discount, false);
        }
      }
    } catch (err) {
      exceptionService.logError(err, "AddLocation.ProcessPayment", user?.id);
      setFormValidateErrorMessage("There was a problem saving. " + err.message);
    } finally {
      setProcessingPayment(false);
    }
  };

  const validateBusinessInfo = () => {
    const newErrors: { [key: string]: string } = {};
    if (!name) newErrors.name = MESSAGES_VALIDATION.VALIDATION_REQUIRED_BUSINESS_NAME;
    if (!address) newErrors.address = MESSAGES_VALIDATION.VALIDATION_REQUIRED_ADDRESS;
    if (!city) newErrors.city = MESSAGES_VALIDATION.VALIDATION_REQUIRED_CITY;
    if (!stateValue || stateValue == "State")
      newErrors.state = MESSAGES_VALIDATION.VALIDATION_REQUIRED_STATE;
    if (!zip) newErrors.zip = MESSAGES_VALIDATION.VALIDATION_REQUIRED_ZIP;
    if (!phone) {
      newErrors.phone = MESSAGES_VALIDATION.VALIDATION_REQUIRED_PHONE_NUMBER;
    } else {
      if (!validatePhone(phone)) newErrors.phone = MESSAGES_VALIDATION.VALIDATION_PHONE_NUMBER;
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const verifyAddress = async () => {
    try {
      const newErrors: { [key: string]: string } = {};
      if (!address) newErrors.address = MESSAGES_VALIDATION.VALIDATION_REQUIRED_ADDRESS;
      if (!city) newErrors.city = MESSAGES_VALIDATION.VALIDATION_REQUIRED_CITY;
      if (!stateValue) newErrors.state = MESSAGES_VALIDATION.VALIDATION_REQUIRED_STATE;
      if (!zip) newErrors.zip = MESSAGES_VALIDATION.VALIDATION_REQUIRED_ZIP;
      setErrors(newErrors);

      if (!address || !city || !stateValue || !zip) {
        return false;
      }
      setVerifingAddress(true);

      const addressToVerify: VerifyAddressInputType = {
        address: {
          regionCode: "US",
          addressLines: [address, city + " " + stateValue + " " + zip],
        },
      };
      //verify the address
      const result: VerifyAddressResultType = await googleAPIService.verifyAddress(addressToVerify);

      if (result.addressConfirmed) {
        if (result.isPOBox) {
          //showSnackbar(MESSAGES_ADDRESS_VERIFICATION.ADDRESS_VERIFICATION_POBOX_NOT_ALLOWED);

          setAddressConfirmed(false);
          return;
        }

        const {
          street,
          city: cityVerified,
          state: stateVerified,
          zip: zipVerified,
          country,
          longitude,
          latitude,
          placeId,
        } = parseAddress(result.formattedAddress);

        if (
          address !== street ||
          city !== cityVerified ||
          stateValue !== stateVerified ||
          zip !== zipVerified
        ) {
          // show address picker
          setAddressPicked(2);
          setAddressesForPicker([
            //{ id: 1, name: 'Entered Address', address, city, state: stateValue, zip, longitude, latitude, placeId: '', isBusiness: false },
            {
              id: 2,
              name: "Verified Address",
              address: street,
              city: cityVerified,
              state: stateVerified,
              zip: zipVerified,
              country,
              longitude: result.location.longitude,
              latitude: result.location.latitude,
              placeId,
              isBusiness: result.isBusiness || !result.isResidential,
            },
          ]);
          setShowAddressPickerModal(true);
          return;
        } else {
          //address is good
          setAddress(result.formattedAddress.slice(0, result.formattedAddress.indexOf(",")));
          setLongitude(result.location.longitude);
          setLatitude(result.location.latitude);
          setPlaceId(result.placeId);
          setAddressConfirmed(true);
          setCity(cityVerified);
          setStateValue(stateVerified);
          setZip(zipVerified);

          setIsBusiness(result.isBusiness);

          if (result.isBusiness) setStep(2); // proceed to next step
          else setShowAddressNotBusinessVerifyModal(true);
        }
      } else {
        setAddressConfirmed(false);
        //showSnackbar(MESSAGES_ADDRESS_VERIFICATION.ADDRESS_VERIFICATION_NOT_ABLE_TO_CONFIRM_ADDRESS);
      }
    } catch (error: any) {
      exceptionService.logError(error, "AddLocationMD.verifyAddress", user?.id);
      setFormValidateErrorMessage("There was a problem verifying the address: " + error.message);
    } finally {
      setVerifingAddress(false);
    }
  };

  const handleOnAddressPicked = async (id: number) => {
    if (id != null) {
      //get the address from the modal and reverify
      setAddressPicked(id);
      //hide modal
      setShowAddressPickerModal(false);
      //verify the address
      const newAddy = addressesForPicker?.find((a) => a.id == id);
      if (newAddy != null) {
        setAddress(newAddy.address);
        setCity(newAddy.city);
        setStateValue(newAddy.state);
        setZip(newAddy.zip);
        setLongitude(newAddy.longitude);
        setLatitude(newAddy.latitude);
        setIsBusiness(newAddy.isBusiness);
        setPlaceId(newAddy.placeId);
        setAddressConfirmed(true);
      }
      if (newAddy.isBusiness) {
        setCheckingForLocationExits(true);
        businessInfoVerifyLocationNotExists();
      } else setShowAddressNotBusinessVerifyModal(true);
    }
  };
  const handleAddressNotBusinessModalAccept = async () => {
    setCheckingForLocationExits(true);
    businessInfoVerifyLocationNotExists();
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={4}>
        <Grid container spacing={4} justifyContent="center" alignItems="flex-start">
          {step != 7 && (
            <Grid item xs={12} md={4}>
              <AddLocationInstructionSection
                stepNumber={step}
                freeForeverAvailable={freeForeverAvailable}
              />
            </Grid>
          )}
          {/* RIGHT: Existing Card */}
          <Grid item xs={12} md={8}>
            <Card
              sx={{ maxWidth: 700, mx: "auto", p: 3, border: "1px solid #ccc", borderRadius: 2 }}
            >
              <MDBox>
                {showAddressNotBusinessVerifyModal && (
                  <AddressNotBusinessVerifyModal
                    title="Confirm Address"
                    message="This address does not validate as a business. That is okay, but we like to confirm. Things such as parks and churches will show this."
                    visible={showAddressNotBusinessVerifyModal}
                    confirmText="Accept Address"
                    cancelText="Review Address"
                    onConfirm={() => {
                      setShowAddressNotBusinessVerifyModal(false);
                      handleAddressNotBusinessModalAccept();
                    }}
                    onCancel={() => {
                      setShowAddressNotBusinessVerifyModal(false);
                      setStep(1);
                    }}
                  />
                )}
                {showLocationAlreadyExistsModal && (
                  <LocationAlreadyExistsModal
                    visible={showLocationAlreadyExistsModal}
                    onConfirm={() => {
                      setShowLocationAlreadyExistsModal(false);
                    }}
                  />
                )}

                {showAddressPickerModal && (
                  <AddressPickerModal
                    visible={showAddressPickerModal}
                    currentSelectedAddressId={addressPicked}
                    addresses={addressesForPicker}
                    onAddressPicked={(id: number | null) => {
                      handleOnAddressPicked(id);
                    }}
                    onCancel={() => setShowAddressPickerModal(false)}
                  />
                )}

                {saving && (
                  <MDBox sx={{ display: "flex", justifyContent: "center", my: 2 }}>
                    <CircularProgress />
                    <MDTypography sx={{ ml: 2 }}>Saving location...</MDTypography>
                  </MDBox>
                )}
                {step === 1 && (
                  <MDBox>
                    <MDTypography variant="h6">Business Information</MDTypography>
                    <MDTypography
                      variant="caption"
                      mb={2}
                      sx={{
                        lineHeight: "1.3", // controls spacing between wrapped lines
                        display: "block", // ensures proper wrapping
                        whiteSpace: "normal", // prevents forced extra spacing
                      }}
                    >
                      Enter the name address of the location where users will find the restroom.
                    </MDTypography>
                    <MDInput
                      label="Business Name"
                      fullWidth
                      margin="normal"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      error={!!errors.name}
                      helperText={errors.name}
                    />

                    <MDInput
                      label="Address"
                      fullWidth
                      margin="normal"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      error={!!errors.address}
                      helperText={errors.address}
                    />

                    <MDInput
                      label="City"
                      fullWidth
                      margin="normal"
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                      error={!!errors.city}
                      helperText={errors.city}
                    />

                    {/* State */}
                    <MDBox mt={2}>
                      <MDInput
                        select
                        fullWidth
                        name="state"
                        value={stateValue}
                        onChange={(e) => setStateValue(e.target.value)}
                        displayEmpty
                        error={Boolean(errors.state)} // ← THIS IS WHAT TRIGGERS MDInput error styles
                        InputProps={{
                          sx: {
                            height: 45,
                            display: "flex",
                            alignItems: "center",
                            color: (theme) => theme.palette.text.primary,
                            "& .MuiSelect-select": {
                              color: (theme) => theme.palette.text.primary,
                              display: "flex",
                              alignItems: "center",
                              minHeight: "45px",
                            },
                            "& .MuiSelect-select.MuiInputBase-input": {
                              color: (theme) => theme.palette.text.primary,
                            },
                            "& .MuiOutlinedInput-input": {
                              color: (theme) => theme.palette.text.primary,
                            },
                            "& .MuiSelect-select.MuiPlaceholder-root": {
                              color: (theme) => theme.palette.text.primary,
                              opacity: 0.7,
                            },
                          },
                        }}
                      >
                        <MenuItem value="State">State</MenuItem>
                        {states &&
                          states.map((state) => (
                            <MenuItem key={state.value} value={state.value}>
                              {state.name}
                            </MenuItem>
                          ))}
                      </MDInput>
                      {errors.state && (
                        <FormHelperText style={{ marginLeft: 14 }}>{errors.state}</FormHelperText>
                      )}
                    </MDBox>

                    <MDInput
                      label="Zip Code"
                      fullWidth
                      margin="normal"
                      value={zip}
                      onChange={(e) => setZip(e.target.value)}
                      error={!!errors.zip}
                      helperText={errors.zip}
                    />

                    <MDInput
                      label="Phone Number"
                      fullWidth
                      margin="normal"
                      value={formatPhoneNumber(phone)}
                      onChange={(e) => setPhone(e.target.value)}
                      error={!!errors.phone}
                      helperText={errors.phone}
                      placeholder="(XXX) XXX-XXXX"
                    />
                  </MDBox>
                )}
                {/* end step 1 */}
                {step == 2 && (
                  <MDBox>
                    <MDTypography variant="h6">Business Hours</MDTypography>
                    <MDTypography
                      variant="caption"
                      sx={{
                        lineHeight: "1.3", // controls spacing between wrapped lines
                        display: "block", // ensures proper wrapping
                        whiteSpace: "normal", // prevents forced extra spacing
                      }}
                    >
                      Enter the business hours for the location.
                    </MDTypography>
                    <MDBox mx={2} py={2} px={2} borderRadius="lg">
                      <MDBox display="flex" flexDirection="column" gap={2}>
                        <LocationHours
                          showTitle={false}
                          editMode={true}
                          is24Hours={is24Hours}
                          setIs24Hours={(value) => setIs24Hours((prev) => value)}
                          currentHours={businessHours}
                          saveHours={(hours) => setBusinessHours((prev) => hours)}
                        />
                        {is24Hours && (
                          <MDTypography variant="caption">
                            Location is set to Open 24 Hours - toggle off to set specific business
                            hours.
                          </MDTypography>
                        )}
                      </MDBox>
                    </MDBox>
                  </MDBox>
                )}
                {/* end step 2 */}
                {step == 3 && (
                  <MDBox>
                    <MDTypography variant="h6" fontWeight="medium">
                      Door Lock Settings
                    </MDTypography>
                    <MDTypography
                      variant="caption"
                      sx={{
                        lineHeight: "1.3", // controls spacing between wrapped lines
                        display: "block", // ensures proper wrapping
                        whiteSpace: "normal", // prevents forced extra spacing
                      }}
                    >
                      Select if your restroom requires a door lock code for entry. Then, select if
                      the restroom is always locked, or only locked during specific hours.
                    </MDTypography>
                    <MDBox mx={2} px={2} borderRadius="lg">
                      <MDBox display="flex" flexDirection="column" gap={2} mt={2}>
                        {/* Require Door Lock */}
                        <MDBox display="flex" justifyContent="space-between" alignItems="center">
                          <MDTypography
                            sx={{ fontSize: "0.875rem", fontWeight: 400, color: "text.primary" }}
                          >
                            Require Door Lock Code for Restroom Entry?
                          </MDTypography>
                          <Switch
                            checked={doorLockCodeRequired}
                            onChange={(e) => setDoorLockCodeRequired((prev) => e.target.checked)}
                            color="info"
                          />
                        </MDBox>

                        {/* Conditional Fields */}
                        {doorLockCodeRequired ? (
                          <>
                            {/* Door Lock Code */}
                            <MDBox>
                              <MDTypography variant="caption" color="text" mb={1} fontWeight="bold">
                                Door Lock Code
                              </MDTypography>
                              <MDInput
                                fullWidth
                                name="doorLockCode"
                                value={doorLockCode}
                                onChange={setDoorLockCode}
                              />
                              <MDTypography
                                variant="caption"
                                color="text"
                                fontWeight="regular"
                                mt={0.5}
                                sx={{
                                  lineHeight: "1.3", // controls spacing between wrapped lines
                                  display: "block", // ensures proper wrapping
                                  whiteSpace: "normal", // prevents forced extra spacing
                                }}
                              >
                                App users will enter this code into the keypad to unlock the
                                restroom.
                              </MDTypography>
                            </MDBox>

                            {/* Time Per Visit */}
                            <MDBox>
                              <MDTypography variant="caption" color="text" mb={1} fontWeight="bold">
                                Time per Visit (minutes)
                              </MDTypography>
                              <MDInput
                                fullWidth
                                name="timePerVisit"
                                value={timeAllowed}
                                onChange={setTimeAllowed}
                              />
                              <MDTypography
                                variant="caption"
                                color="text"
                                fontWeight="regular"
                                mt={0.5}
                                sx={{
                                  lineHeight: "1.3", // controls spacing between wrapped lines
                                  display: "block", // ensures proper wrapping
                                  whiteSpace: "normal", // prevents forced extra spacing
                                }}
                              >
                                The time in minutes that an app user is allowed to use the restroom
                                before the app warns them.
                              </MDTypography>
                            </MDBox>

                            {/* QR Reader */}
                            <MDBox
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              <MDTypography
                                sx={{
                                  fontSize: "0.875rem",
                                  fontWeight: 400,
                                  color: "text.primary",
                                }}
                              >
                                Door Lock Uses QR Reader
                              </MDTypography>
                              <Switch
                                checked={useQRCode}
                                onChange={(e) => setUseQRCode((prev) => e.target.checked)}
                                color="info"
                              />
                            </MDBox>
                            <MDTypography variant="caption" mt={-3}>
                              {" "}
                              If you have a QR code reader installed on your door lock, enable this
                              option.
                            </MDTypography>

                            <MDBox display="flex" flexDirection="column" gap={2}>
                              <LocationDoorLockHours
                                editMode={true}
                                doorLockAlwaysLocked={doorLockAlwaysLocked}
                                setDoorLockAlwaysLocked={(value) =>
                                  setDoorLockAlwaysLocked((prev) => value)
                                }
                                currentHours={doorLockHours}
                                saveHours={(hours) => setDoorLockHours((prev) => hours)}
                              />
                            </MDBox>
                          </>
                        ) : (
                          <MDTypography variant="caption" color="error" fontWeight="medium" p={0}>
                            No door lock is required! Do this only if your restroom has no lock. App
                            users will not be required to take a post-use picture.
                          </MDTypography>
                        )}
                      </MDBox>
                    </MDBox>
                  </MDBox>
                )}
                {/* end step 3 */}
                {step == 4 && (
                  <MDBox>
                    <MDTypography variant="h6" fontWeight="medium">
                      Options & Amenities
                    </MDTypography>
                    <MDTypography
                      variant="caption"
                      color="text"
                      fontWeight="regular"
                      sx={{
                        lineHeight: "1.3", // controls spacing between wrapped lines
                        display: "block", // ensures proper wrapping
                        whiteSpace: "normal", // prevents forced extra spacing
                      }}
                    >
                      Select all that apply to this location. App users will search and filter by
                      these options to find exactly what they need.
                    </MDTypography>
                    <MDBox mx={2} py={1} px={2} borderRadius="lg">
                      <MDBox display="flex" flexWrap="wrap" mt={2} gap={2}>
                        {amenitiesList.map((amenity) => {
                          const item = amenityStateMap[amenity.key];
                          if (!item) return null; // in case future amenities get added

                          return (
                            <MDButton
                              key={amenity.key}
                              variant={item.value ? "gradient" : "outlined"}
                              color="info"
                              onClick={() => item.setter(!item.value)}
                            >
                              {amenity.label}
                            </MDButton>
                          );
                        })}
                      </MDBox>
                    </MDBox>
                  </MDBox>
                )}
                {/* end step 4 */}
                {step == 5 && (
                  <MDBox>
                    {(freeForeverAvailable && (
                      <MDBox
                        mx="auto"
                        sx={{
                          width: "100%",
                          maxWidth: "600px",
                          textAlign: "center",
                        }}
                      >
                        {/* Highlight Banner */}
                        <MDBox
                          p={2}
                          borderRadius="lg"
                          sx={{
                            //background: "linear-gradient(135deg, #1226d6ff, #3600fa96)", // light teal to white
                            color: "white",
                          }}
                        >
                          {/* Logo */}
                          <MDBox display="flex" justifyContent="center" mb={2}>
                            <MainLogo hideText style={{ width: 120 }} />
                          </MDBox>
                          <MDTypography variant="h5" fontWeight="bold">
                            🎉 Free Forever Hosting!
                          </MDTypography>
                          <MDTypography variant="body2" sx={{ mt: 1 }}>
                            {MESSAGES_LOCATION.OPTIONS_FREE_FOREVER}
                          </MDTypography>
                        </MDBox>

                        {/* Main Info */}
                        <MDTypography variant="h5" fontWeight="bold" sx={{ mb: 1 }}>
                          Thank you for being one of the first 100 hosts!
                        </MDTypography>
                        <MDTypography variant="body1" sx={{ mt: 1 }}>
                          There is no catch!
                        </MDTypography>
                        <MDTypography variant="body1" sx={{ mt: 1 }}>
                          This location will receive hosting <strong>free… forever!</strong>
                        </MDTypography>
                        {/* Representative Field */}
                        <MDBox mt={2} textAlign="left">
                          <MDTypography variant="subtitle2" sx={{ mb: 1 }}>
                            Representative:
                          </MDTypography>

                          <MDInput
                            fullWidth
                            placeholder="Name of your local Rep"
                            value={localRep}
                            onChange={(e) => setLocalRep(e.target.value)}
                            inputProps={{ style: { textTransform: "uppercase" } }}
                          />
                        </MDBox>
                      </MDBox>
                    )) || (
                      <HostingPlanSelector
                        onSelectPlan={setSelectedPricingPlan}
                        selectedPlanId={selectedPricingPlan}
                      />
                    )}
                  </MDBox>
                )}
                {step == 6 && (
                  <MDBox
                    display="flex"
                    flexDirection="column"
                    gap={2}
                    width="100%"
                    maxWidth="600px"
                    mx="auto"
                    px={2}
                  >
                    <MDTypography variant="h6">Payment Information</MDTypography>
                    <MDTypography variant="caption" pb={2} sx={{ textAlign: "center" }}>
                      Enter your payment information to start hosting {APP_NAME} users today!
                    </MDTypography>
                    <MDBox>
                      <MDTypography variant="subtitle2" sx={{ mb: 1 }}>
                        Credit Card Information
                      </MDTypography>
                      <MDBox sx={{ border: "1px solid #21b2a6", borderRadius: 1, p: 1 }}>
                        {cardElement}
                      </MDBox>
                    </MDBox>
                    <MDBox>
                      <MDTypography variant="subtitle2" sx={{ mb: 1 }}>
                        Coupon Code
                      </MDTypography>
                      <MDInput
                        fullWidth
                        placeholder=""
                        value={couponCode}
                        onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
                        inputProps={{ style: { textTransform: "uppercase" } }}
                      />
                    </MDBox>
                    <MDBox>
                      <MDTypography variant="subtitle2" sx={{ mb: 1 }}>
                        Representative
                      </MDTypography>
                      <MDInput
                        fullWidth
                        placeholder="Name of your local Rep"
                        value={localRep}
                        onChange={(e) => setLocalRep(e.target.value)}
                      />
                    </MDBox>
                    <MDTypography variant="caption" color="text">
                      Credit card charges will appear as 'Macke's Software' and are billed monthly.{" "}
                      <br />
                      We do NOT store your credit card information! Subscriptions are managed via
                      Stripe.
                    </MDTypography>
                    <MDBox display="flex" alignItems="center" gap={1}>
                      <MDInput
                        type="checkbox"
                        checked={agreeToRecurring}
                        onChange={(e) => setAgreeToRecurring(e.target.checked)}
                      />
                      <MDTypography variant="body2">
                        I understand and agree to recurring payments of{" "}
                        {selectedPricingPlan === 1 ? "$9.99" : "$19.99"} per month.
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                )}
                {step == 7 && (
                  <MDBox flex={1} justifyContent="center" alignItems="center" p={3}>
                    {/* Logo */}
                    <MDBox display="flex" justifyContent="center" mb={2}>
                      <MainLogo hideText style={{ width: 120 }} />
                    </MDBox>

                    {/* Title */}
                    <MDTypography variant="h4" fontWeight="700" textAlign="center" mb={1}>
                      Location Submitted!
                    </MDTypography>

                    <MDTypography
                      variant="subtitle1"
                      fontWeight="500"
                      textAlign="center"
                      color="text.secondary"
                      mb={3}
                    >
                      Your submission is now pending approval
                    </MDTypography>

                    {/* Main message */}
                    <MDTypography variant="body1" textAlign="center" mb={2}>
                      Thank you for adding your location! Our team will review your submission and
                      contact you shortly to verify your business details.
                    </MDTypography>
                    <MDBox my={2}>
                      <Divider />
                    </MDBox>
                    <MDTypography variant="body2" textAlign="center" mb={1}>
                      Your restroom is one step closer to becoming an asset for your business. While
                      you wait for approval, you are be able to customize hosting settings, update
                      your door code, and prepare to start welcoming new foot traffic with less
                      staff effort.
                    </MDTypography>
                    <MDTypography variant="h6" textAlign="center" fontWeight="600" mt={3}>
                      Welcome aboard!
                    </MDTypography>
                  </MDBox>
                )}
                {verifingAddress ||
                  (checkingForLocationExits && (
                    <LoadingSpinner title="Verifying address..." fontVariant="body1" />
                  ))}
                {formValidateErrorMessage && (
                  <MDTypography color="error" mt={1}>
                    {formValidateErrorMessage}
                  </MDTypography>
                )}

                <MDBox sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
                  <MDButton
                    variant="outlined"
                    color="secondary"
                    onClick={handleBack}
                    disabled={saving}
                  >
                    {backText()}
                  </MDButton>
                  <MDButton color="info" onClick={handleNext} disabled={saving}>
                    {nextText()}
                  </MDButton>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <NotificationAlert
        open={showSnackBar}
        onClose={closeSnackBar}
        close={closeSnackBar}
        color={snackbar.color}
        icon={snackbar.icon}
        title={snackbar.title}
        content={snackbar.content}
        dateTime={snackbar.dateTime}
      />
    </DashboardLayout>
  );
};

export default AddLocation;
